/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BasePrice } from './BasePrice';
import { CourseOfCoursePrice } from './CourseOfCoursePrice';
const CoursePriceParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('course-price')],
    ['course', CourseOfCoursePrice],
    ['editable', codecBoolean],
]), BasePrice);
export class CoursePrice extends BasePrice {
    static decode(input) {
        return CoursePriceParser.decode(input).map(res => new CoursePrice(res));
    }
    static unsafeDecode(input) {
        return CoursePrice.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CoursePriceParser.encode(data);
    }
    static schema() {
        return CoursePriceParser.schema();
    }
}
